import type { GameItem } from "@/lib/types";
import { formatScore, gameHref } from "../utils";

interface Props {
  game: GameItem;
}

// 게임 카드 한 장 — 메인 섹션과 /games 페이지가 함께 쓴다.
// 카드 개수·이름·아이콘은 전부 games.php 응답에서 오고 코드에 박지 않는다.
export default function GameCard({ game }: Props) {
  const unit = game.unit ?? "점";
  const top = game.top;
  const spinLeft = game.spin_left;
  const mine = Number(game.my_best ?? 0);

  return (
    <a
      href={gameHref(game)}
      className="group relative flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
    >
      {/* 룰렛만: 오늘 남은 횟수 뱃지 */}
      {typeof spinLeft === "number" && (
        <span
          className={`absolute right-3 top-3 rounded-full px-2 py-0.5 text-[11px] font-semibold ${
            spinLeft > 0
              ? "bg-secondary-100 text-secondary-900"
              : "bg-background-200 text-foreground-500"
          }`}
        >
          {spinLeft > 0 ? `오늘 ${spinLeft}회 남음` : "내일 다시"}
        </span>
      )}

      <span className="text-[32px] leading-none" aria-hidden="true">
        {game.icon || "🎮"}
      </span>

      <p className="mt-2.5 font-heading text-[15px] font-bold text-foreground-950">
        {game.name}
      </p>
      {game.desc && (
        <p className="mt-1 truncate text-xs text-foreground-500">{game.desc}</p>
      )}

      <div className="mt-3 flex-1"></div>

      {top && (top.txt || top.name) ? (
        <p className="flex items-center gap-1 text-xs font-semibold text-accent-700">
          <span aria-hidden="true">👑</span>
          <span className="truncate">{top.txt || `${top.name} · ${formatScore(top.score)}${unit}`}</span>
        </p>
      ) : (
        <p className="text-xs text-foreground-400">첫 기록의 주인공이 되어보세요</p>
      )}

      {mine > 0 && (
        <p className="mt-1 text-[11px] text-foreground-500">
          내 최고 {formatScore(mine)}
          {unit}
        </p>
      )}
    </a>
  );
}